import { ComponentType } from "preact";
import { preact, JSX } from "../../Core/References";
import { AutoComplete } from "../AutoComplete/AutoComplete";
import { DataControl, IDataControlProps } from "../DataControl/DataControl";
import { ValueList } from "../ValueList/ValueList";
import { $$requestManager } from "../../Core/RequestManager";

export interface IAutoCompleteGroupProps extends IDataControlProps
{
    CreateComponent?: ComponentType;
    CreateData?: any;
    LookupService: string;
    LoadRecordService?: string;
    Mini?: boolean;
    Descriptor?: string;
    Context?: string;
}

export class AutoCompleteGroup extends DataControl<IAutoCompleteGroupProps>
{
    private _autoComplete: AutoComplete;
    private _valueList: ValueList<KeyValue>;
    private _exclusions: string[];

    constructor(props: IAutoCompleteGroupProps)
    {
        super(props);

    }

    public override componentDidUpdate()
    {
        var values = this.getValue() || [] as KeyValue[];
        let rawValues = values.map((item, index) => (item.Key));
        this._autoComplete.setExclusions(rawValues);
    }

    public setValue(values: KeyValue[])
    {
        this._valueList.setValue(values);
        this._updateExclusions();
    }

    public setExclusions(values: string[])
    {
        this._exclusions = values;
        this._updateExclusions();
    }

    private _updateExclusions(): void
    {
        let ids = this.getIds();
        if (this._exclusions?.length > 0)
        {
            ids = ids.concat(this._exclusions);
        }
        this._autoComplete.setExclusions(ids);
    }

    public getValue(): { Key: string }[]
    {
        return this._valueList.getValue() as any;
    }

    public override getValueRaw(): string[]
    {
        return this.getIds();
    }

    public focus()
    {
        this._autoComplete.focus();
    }

    public getIds(): string[]
    {
        return this._valueList.getIds();
    }

    private _handleAutoCompleteChange(keyValue: KeyValue)
    {
        this._valueList.addValue(keyValue);
        this._autoComplete.setValue(null);
    }

    private _onValueSelected(value: string)
    {
        if (this.props.CreateComponent)
        {
            $$requestManager.execute(this.props.LoadRecordService, parseInt(value), this._onLoadRecordSuccess.bind(this), this._onLoadRecordFailure.bind(this));
        }
    }

    private _onLoadRecordSuccess(data)
    {
        if (this.props.CreateComponent)
        {
            this._autoComplete.editRecord(data);
        }
    }

    private _onLoadRecordFailure()
    {

    }

    private _onValueRemoved()
    {
        this._autoComplete.focus();
    }

    public render(): JSX.Element
    {
        return (
            <span className="autogroupContainer" ref={(container) => this._registerContainer(container)}>
                <AutoComplete
                    Descriptor={this.props.Descriptor}
                    ref={(autoComplete) => { this._autoComplete = autoComplete }}
                    onChange={this._handleAutoCompleteChange.bind(this)}
                    Context={this.props.Context}
                    CreateComponent={this.props.CreateComponent}
                    CreateData={this.props.CreateData}
                    LookupService={this.props.LookupService}
                    style={ this.props.style || { marginRight: "5px" }} />

                <ValueList
                    Mini={this.props.Mini}
                    ref={(ref) => this._valueList = ref}
                    OnRemoveItem={this._onValueRemoved.bind(this)}
                    OnSelectItem={this._onValueSelected.bind(this) } />
            </span>);
    }
}